<template>
  <div class="action-controls">
    <template v-for="quickAction in params.data.actions.quickActions">
      <v-icon dense :key="quickAction.name" :class="'pr-3 quick-icon ' + quickAction.class" @click="performAction(quickAction, params)" :title="quickAction.label">{{quickAction.icon}}</v-icon>
    </template>
    <v-menu v-if="params.data.actions.menuActions.length > 0" left offset-y close-on-click @input="updateMenuState">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon :color="menuColor" class="ellipses-control">
          <v-icon dense>{{menuIcon}}</v-icon>
        </v-btn>
      </template>
      <v-list class="ellipses-control-option-list">
        <template v-for="(menuAction, index) in params.data.actions.menuActions">
          <v-list-item v-if="menuAction" :key="menuAction.name" @click="performAction(menuAction, params)">
            <v-list-item-title class="ellipses-control-option">{{menuAction.label}}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!menuAction" :key="index" class="py-0 my-0">---------------------------------------</v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'ActionsCellRenderer',
    data() {
      return {
        menuOpen: false
      };
    },
    methods: {
      updateMenuState(isOpen) {
        this.menuOpen = isOpen;
      },
      performAction(action, params) {
        if (this.params.callback) {
          this.params.callback(action, params);
        }
      }
    },
    computed: {
      menuIcon() {
        return this.menuOpen ? 'mdi-dots-horizontal-circle' : 'mdi-dots-horizontal';
      },
      menuColor() {
        return 'var(--v-resBlue-darken1)';
      }
    },
    mounted() {
      //console.log('ActionsCellRenderer'); // uncomment to see how often component is rendering
    }
  }
</script>

<style scoped lang="scss">
  .action-controls {
    padding: 0;
    margin: 0;
  }
  .quick-icon {
    color: var(--v-resBlue-darken1);
  }
  .ellipses-control {
    height: 20px;
    width: 20px;
  }
  .ellipses-control-option-list {
    border-radius: 6px;
    border: 1px solid var(--v-resBlue-darken1);
  }
  .ellipses-control-option {
    font-size: 13px;
  }
</style>
